$(document).on('turbolinks:load', function(){
  if ($('.homepage-section').length) {
    setTimeout(
      function() {
        $('.newsletter-modal').modal('toggle');
      }, 10000
    );

    $('#new_powertalks_items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: '#new_powertalks_items_btn__prev',
      nextArrow: '#new_powertalks_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
    $('#ideagen_favorites_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#ideagen_favorites_items_btn__prev',
      nextArrow: '#ideagen_favorites_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  
    $('#summit_highlights_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#summit_highlights_items_btn__prev',
      nextArrow: '#summit_highlights_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  
    $('#member_networking_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#member_networking_items_btn__prev',
      nextArrow: '#member_networking_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    }); 
  
    $('#catalyze_magazine_items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: '#catalyze_magazine_items_btn__prev',
      nextArrow: '#catalyze_magazine_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
    $('#ideagen_tv_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#ideagen_tv_items_btn__prev',
      nextArrow: '#ideagen_tv_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  
    $('#global_leader_podcasts_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#global_leader_podcasts_items_btn__prev',
      nextArrow: '#global_leader_podcasts_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  
    $('#sustainable_development_goals_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#sustainable_development_goals_items_btn__prev',
      nextArrow: '#sustainable_development_goals_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  
    $('#sponsor_highlight_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#sponsor_highlight_items_btn__prev',
      nextArrow: '#sponsor_highlight_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });

    $('#highlighted_sponsor_highlight_items').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '#highlighted_sponsor_highlight_items_btn__prev',
      nextArrow: '#highlighted_sponsor_highlight_items_btn__next',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });

    if (window.location.hash === '#free-e-membership') {
      if ($('#navbarSupportedContent').find('[data-target="#sign_in_modal"]').length){
        $('#navbarSupportedContent').find('[data-target="#sign_in_modal"]').click();
      } else {
        toastr.error('You are already a member.');
      }
    }
  }
});